import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TENANT_PLATFORM } from "@hiver/bifrost-js/lib";

import { ToastContext } from "../../Context";
import { completeOAuthHGT, completeOAuthHOT } from "../../Service/LoginServices";
import { setState, STORAGE_KEYS } from "../../Constants/LocalStorage";
import { NewCategoryLoader } from "../../Components/Loaders/NewCategoryLoader";

const completeOAuthApis = {
    [ TENANT_PLATFORM.GMAIL ]: completeOAuthHGT,
    [ TENANT_PLATFORM.HIVERWEB ]: completeOAuthHOT
}

const CompleteAuth = () => {

    const { setShowToast } = useContext(ToastContext);
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);

    const email = queryParams.get('email');
    const sso_auth_token = queryParams.get('sso_auth_token');
    const tenant = queryParams.get('tenant') || TENANT_PLATFORM.HIVERWEB;
    const hot_session = queryParams.get('hot_session');

    useEffect( () => {
        let active = true;

        (async () =>{

            // Direct session transfer from Omni admin panel.
            // Stores the Devise session headers directly, bypassing backend sign_in
            // which rejects raw access-tokens (expects SSO code).
            if (tenant === TENANT_PLATFORM.HIVERWEB && hot_session) {
                try {
                    const sessionData = JSON.parse(atob(hot_session));
                    setState(STORAGE_KEYS.HOT_SESSION_DATA, sessionData);
                    setState(STORAGE_KEYS.KB_ACTIVE_TENANT, TENANT_PLATFORM.HIVERWEB);
                    window.location.assign("/");
                    return;
                } catch (_) {
                    // malformed payload — fall through to normal SSO flow
                }
            }

            const completeOAuthApi = completeOAuthApis[ tenant ] ?? completeOAuthApis[TENANT_PLATFORM.HIVERWEB ];
            try {
                if( !sso_auth_token || !email ){
                    throw new Error("Authentication failed!");
                }
                const response = await completeOAuthApi(sso_auth_token,email);
                if( !active ){
                    return;
                }
                if( response.status === 200 ){
                    window.location.assign("/");
                }
                else {
                    throw response;
                }
            }
            catch( error ){
                navigate("/login");
                setShowToast( error?.message || "Login Attempt failed, please try again" );
            }

        })();

        return () => {
            active = false;
        }
    }, [ sso_auth_token, email, tenant, hot_session, navigate ])

    return (
        <NewCategoryLoader />
    )
}

export default CompleteAuth;